import { styled } from "@mui/material/styles";
import MenuItem from "@mui/material/MenuItem";
import { Menu } from "@mui/material";

export const StyledMenu = styled(Menu)(({ theme }) => ({
  "& .MuiPaper-root": {
    boxShadow: "0px 3px 5px 1px rgba(0,0,0,0.1)",
  },
}));

export const StyledMenuItem = styled(MenuItem)(({ theme }) => ({
  display: "flex",
  gap: "12px",
}));
